<template>
  <div class="columns is-centered is-mobile columns-netstat no-margin-horizontal">
    <div class="column is-narrow has-text-centered">
      <div class="status-card">
        <p class="card-icon">
          <img :src="require('../../assets/icon_blocks@2x.png')" alt="">
        </p>
        <p class="heading">BLOCKS</p>
        <p class="title">{{ blocks }}</p>
        <p class="card-line"></p>
        <p class="card-textbox">
          区块数
        </p>
      </div>
    </div>

    <div class="column is-narrow has-text-centered">
      <div class="status-card">
        <p class="card-icon">
          <img :src="require('../../assets/icon_latest@2x.png')" alt="">
        </p>
        <p class="heading">LATEST</p>
        <p class="title">{{ lastBlockTime }}</p>
        <p class="card-line"></p>
        <p class="card-textbox">
          最后出块
        </p>
      </div>
    </div>

    <div class="column is-narrow has-text-centered">
      <div class="status-card">
        <p class="card-icon">
          <img :src="require('../../assets/icon_txrate@2x.png')" alt="">
        </p>
        <p class="heading">TX/SEC</p>
        <p class="title">{{ transactionPerSecond}}</p>
        <p class="card-line"></p>
        <p class="card-textbox">
          每秒交易数
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'FirstNetworkStatusMobile',
    computed: {
      ...mapState(['chainStatus']),
      blocks () {
        return this.$utils.addComma(this.chainStatus.blockHeight)
      },
      lastBlockTime () {
        if (this.chainStatus.lastBlockTime) {
          const last = this.chainStatus.lastBlockTime
          const d = new Date()
          const now = d.getTime()
          if (now / 1000 - last < 30) {
            return '' + parseInt(now / 1000 - last) + 's'
          } else {
            return this.$utils.fromNow(last)
          }
        } else {
          return 'n/a'
        }
      },
      transactionPerSecond () {
        return Number.parseFloat('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3)
      }
    }
  }
</script>

<style scoped lang="scss">
  .columns-netstat {
    position: relative;
    margin-top: -42%;
    margin-bottom: 20%;
  }

  .no-margin-horizontal {
    margin-left: 0;
    margin-right: 0;
  }

  .status-card {
    width: 4.8rem;
    height: 6rem;
    background-image: url("../../assets/status_card_bg@2x.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;

    p.card-icon img {
      margin-top: 8px;
      width: 24px;
      height: 24px;
    }

    p.heading {
      color: #4acb6b;
      font-size: .4rem;
      font-weight: 600;
    }

    p.title {
      color: #4acb6b;
      font-size: .8rem;
      font-weight: normal;
      margin-top: -.1rem;
    }

    p.card-line {
      height: 1px;
      margin-top: -1.2rem;
      background-image: url("../../assets/card_line@2x.png");
      background-position: center;
      background-size: 100% 100%;
      margin-left: .5rem;
      margin-right: .5rem;
    }

    p.card-textbox {
      color: #4acb6b;
      font-size: .5rem;
      font-weight: normal;
      border: 1px solid #4acb6b;
      margin-left: .5rem;
      margin-right: .5rem;
      padding-top: .1rem;
      padding-bottom: .1rem;
      margin-top: .2rem;
    }
  }

  .level-netstat {
    position: relative;
    margin-top: -40%;
    margin-bottom: 20%;
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/FirstNetworkStatusMobile.vue